export const entityName = 'marker_panel'

export default {
  entityName
}
